import script from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/LoadingOverlay.scss?vue&type=style&index=0&id=6e174ad0&lang=scss&scoped=true"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e174ad0"]])

export default __exports__